import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { translationKeys } from '../../../../sharedTranslationKeys';

@Component({
  selector: 'avano-notifications-header',
  templateUrl: './avano-notifications-header.component.html',
  styleUrls: ['./avano-notifications-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AvanoNotificationsHeaderComponent {

  @Output()
  private readonly unreadChange: EventEmitter<boolean> =  new EventEmitter<boolean>();

  @Input()
  unread: boolean;

  translationKeys: typeof translationKeys = translationKeys;

  toggleUnread(unread: boolean): void {
    this.unreadChange.emit(unread);
  }
}
